import { BeakerIcon, ShieldCheckIcon, LinkIcon, SignalIcon, KeyIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ConfigMenuItem {
    link: string;
    icon: React.ReactNode;
    text: string;
    childRoutes?: string[];
}

export function getConfigMenuItems(): ConfigMenuItem[] {
    return [
        {
            link: '/super-admin/config/roles',
            icon: <ShieldCheckIcon className="w-6 h-6" />,
            text: 'Rôles systèmes'
        },
        {
            link: '/super-admin/config/plugs',
            icon: <LinkIcon className="w-6 h-6" />,
            text: 'Plugs'
        },
        {
            link: '/super-admin/config/pms-connectivity',
            icon: <SignalIcon className="w-6 h-6" />,
            text: 'Connectivité PMS'
        },
        {
            link: '/super-admin/config/saml',
            icon: <KeyIcon className="w-6 h-6" />,
            text: 'SAML / SSO'
        },
        {
            link: '/super-admin/demo',
            icon: <BeakerIcon className="w-6 h-6" />,
            text: 'Hôtel de démo'
        },
    ];
}
